import { combineReducers } from 'redux';

import pending from './pending';
import map from './map';

export default combineReducers({
    pending,
    map,
});
